/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Or_Login_WithInputs */

const en_mobile_or_login_with = /** @type {(inputs: Mobile_Or_Login_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or login with`)
};

const es_mobile_or_login_with = /** @type {(inputs: Mobile_Or_Login_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O inicia sesión con`)
};

/**
* | output |
* | --- |
* | "Or login with" |
*
* @param {Mobile_Or_Login_WithInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_or_login_with = /** @type {((inputs?: Mobile_Or_Login_WithInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Or_Login_WithInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_or_login_with(inputs)
	return en_mobile_or_login_with(inputs)
});